// src/components/nav/SignedInTabBar.tsx
// The mobile bottom tab bar, mounted once in App.tsx so every signed-in page gets it. Desktop shows
// the same tabs in AppTopBar instead, so this is hidden from md up.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AppTabs } from "@/components/nav/AppTabs";

const HIDDEN: RegExp[] = [
  // wall displays and court screens
  /^\/display$/, /^\/community-cup\//, /^\/events\/[^/]+\/(live|court(\/|$))/, /^\/c\/[^/]+\/nights\/[^/]+\/display$/,
  /^\/organizer\/template-builder\/preview/,
  // sign-in and onboarding flows: a mid-flow user must not be pulled away
  /^\/login(\/|$)/, /^\/auth\/callback$/, /^\/claim$/, /^\/welcome$/, /^\/invite\//, /^\/captain\//, /^\/schedule-proposal$/,
  // pages with their own sticky or fixed bottom action bar, which would sit under this one
  /^\/organizer\/events\/new\//, /^\/organizer\/communities\/new$/, /^\/organizer\/communities\/[^/]+\/nights\//,
  /^\/ladders\/[^/]+\/m\/[^/]+\/find$/, /^\/admin\/crm(\/|$)/,
];

export function isTabBarRoute(pathname: string): boolean {
  return !HIDDEN.some((re) => re.test(pathname));
}

export const SignedInTabBar = () => {
  const { user, playerAccount } = useAuth();
  const { pathname } = useLocation();
  // playerAccount is undefined while it loads; waiting avoids the Admin tab popping in late.
  const show = !!user && playerAccount !== undefined && isTabBarRoute(pathname);
  useEffect(() => {
    if (!show) return;
    document.body.classList.add("has-tab-bar");
    return () => document.body.classList.remove("has-tab-bar");
  }, [show]);
  if (!show) return null;
  // z-20: existing fixed footers (z-30) and the install dialog (z-40) sit above this bar.
  return (
    <div className="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background pb-[env(safe-area-inset-bottom)] md:hidden">
      <AppTabs variant="bottom" />
    </div>
  );
};
